import ILegalEntityInput from './ILegalEntityInput';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Alert, Label } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import * as React from 'react';
import FormValidationService from '../../shared/form/FormValidationService';
import FormSelect from '../../components/common/FormSelect';

interface ILegalEntityFormProps {
    input: ILegalEntityInput;
    onChange: (e: any) => void;
    errors: any;
    isEdit: boolean;
    availableCountries: any[];
}

const LegalEntityForm = (props: ILegalEntityFormProps) => {
    return (
        <form>
            <fieldset>
                <legend>{Translate('legalentities/modal/form/legend/legalentity')}</legend>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        props.errors.organizationNumber
                    )}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/organization-number')}
                    </ControlLabel>
                    <FormControl
                        autoFocus
                        type="text"
                        name="organizationNumber"
                        value={
                            props.input.organizationNumber === null
                                ? ''
                                : props.input.organizationNumber
                        }
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.organizationNumber}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.name)}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/name')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="name"
                        value={props.input.name === null ? '' : props.input.name}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.name}</HelpBlock>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/address')}
                    </ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        type="text"
                        name="address"
                        value={props.input.address === null ? '' : props.input.address}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.address}</HelpBlock>
                </FormGroup>
                <FormGroup
                    validationState={FormValidationService.getValidationState(props.errors.email)}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/email')}
                    </ControlLabel>
                    <FormControl
                        type="email"
                        name="email"
                        value={props.input.email === null ? '' : props.input.email}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.email}</HelpBlock>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/web')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="web"
                        value={props.input.web === null ? '' : props.input.web}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.web}</HelpBlock>
                </FormGroup>
                <FormGroup
                    validationState={FormValidationService.getValidationState(
                        props.errors.phoneNumber
                    )}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/phonenumber')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="phoneNumber"
                        value={props.input.phoneNumber === null ? '' : props.input.phoneNumber}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.phoneNumber}</HelpBlock>
                </FormGroup>
                <FormGroup>
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/bgnr')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="bgNr"
                        value={props.input.bgNr === null ? '' : props.input.bgNr}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.bgnr}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.iban)}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/iban')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="iban"
                        value={props.input.iban === null ? '' : props.input.iban}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.iban}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(props.errors.bic)}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/bic')}
                    </ControlLabel>
                    <FormControl
                        type="text"
                        name="bic"
                        value={props.input.bic === null ? '' : props.input.bic}
                        onChange={props.onChange}
                    />
                    <HelpBlock>{props.errors.bic}</HelpBlock>
                </FormGroup>
                <FormGroup
                    className="required"
                    validationState={FormValidationService.getValidationState(
                        props.errors.accountingCountry
                    )}
                >
                    <ControlLabel>
                        {Translate('legalentities/modal/form/input-label/accounting-country')}
                    </ControlLabel>
                    {!props.isEdit && (
                        <div>
                            <FormSelect
                                name="accountingCountry"
                                value={
                                    props.input.accountingCountry === null
                                        ? ''
                                        : props.input.accountingCountry.toString()
                                }
                                onChange={props.onChange}
                            >
                                {props.availableCountries.map((x: any, index: number) => (
                                    <option key={x.id} value={x.id.toString()}>
                                        {Translate(x.name)}
                                    </option>
                                ))}
                            </FormSelect>
                            <HelpBlock>{props.errors.accountingCountry}</HelpBlock>
                        </div>
                    )}
                    {props.isEdit && (
                        <FormControl.Static>
                            {Translate(
                                props.availableCountries.find(
                                    (x) => x.id === props.input.accountingCountry
                                ).name
                            )}
                        </FormControl.Static>
                    )}
                </FormGroup>
            </fieldset>

            {!props.isEdit && (
                <Alert bsStyle={'warning'}>{Translate('legalentities/modal/info-text')}</Alert>
            )}
        </form>
    );
};

export default LegalEntityForm;
